// extracted by mini-css-extract-plugin
module.exports = {"isSensitiveChip":"TagDropdown_isSensitiveChip__Ik+KS","chip":"TagDropdown_chip__kh/wf","option":"TagDropdown_option__YbBiD"};